<template>
  <IQOSModal>
    <div class="busy-container">
        <img src="/icons/busy-panda.svg"> 
        <h1>{{ $t('busy_modal.title') }}</h1>
    </div>
    
  </IQOSModal>
</template>

<script>
export default {

}
</script>

<style scoped>
.busy-container {
    text-align: center;
    width: 100%;
}

.busy-container img {
    width: 25vh;
    max-width: 25vh;
    min-width: 25vh;
    height: auto;
}

.busy-container h1 {
    color: #ededed;
    font-size: 2.2vh;
}
</style>